import { ObjectKeyValueString } from '../helpers/types';

// This Router Locations is set in a separete file as it causes import issue in the Store file :(
export const TERMS_OF_USE_TABS: ObjectKeyValueString = Object.freeze({
  TERMS_OF_USE: 'tou',
  DATA_PROCESSING_AGREEMENT: 'dpa',
});

export const TERMS_OF_USE_LOCATIONS: ObjectKeyValueString = Object.freeze({
  TERMS_OF_USE: `/terms-of-use?tab=${TERMS_OF_USE_TABS.TERMS_OF_USE}`,
  TERMS_OF_USE_FOR_SUB_USERS: '/terms-of-use-for-sub-users',
  TERMS_OF_USE_FOR_DEALERS_SUB_PORTAL: '/terms-of-use-for-dealers-sub-portal',
  TERMS_OF_USE_FOR_MANUFACTURER_SERVICES: '/terms-of-use-for-manufacturer-services',
  DATA_PROCESSING_AGREEMENT: `/terms-of-use?tab=${TERMS_OF_USE_TABS.DATA_PROCESSING_AGREEMENT}`,
  DATA_ACT: '/data-act/legal',
});

export const MANUFACTURER_SERVICES_LOCATIONS: ObjectKeyValueString = Object.freeze({
  THEME_EDITOR: 'theme-editor',
  CONTENT_CARD_CREATOR: 'content-card-creator',
  SPEC_SHEET: 'spec-sheet',
  PRODUCTION_LOGS: 'production-logs',
  ABS_PLANNER: 'abs-planner',
  EBIKE_PICS: 'ebike-pictures',
  EBIKE_MANS: 'ebike-manuals',
});

export const DATA_ACT_LOCATIONS: ObjectKeyValueString = Object.freeze({
  GENERAL: 'general',
  TINKERER: 'tinkerer',
});
